<template>
  <div class="min-h-screen bg-white py-16 px-4">
    <div class="max-w-2xl mx-auto bg-white rounded-lg shadow-md p-8 text-center">
      <div v-if="loading" class="py-12">
        <p class="font-body text-[1.125rem] text-gray-700 leading-[1.75]">Processing your unsubscribe request...</p>
      </div>
      <div v-else-if="success" class="py-12">
        <div class="mb-6">
          <svg class="mx-auto h-16 w-16 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h1 class="font-header text-[1.5rem] font-bold text-primary mb-4">Unsubscribed Successfully</h1>
        <p class="font-body text-[1.125rem] text-gray-700 leading-[1.75] mb-6">
          You have been successfully unsubscribed from our newsletter. We are sorry to see you go!
        </p>
        <p class="font-body text-[1.125rem] text-gray-600 leading-[1.75] mb-6">
          If you change your mind, you can always subscribe again from our website.
        </p>
        <a href="/"
          class="inline-block px-6 py-3 bg-green-700 text-white rounded-md hover:bg-green-800 transition-colors font-header">
          Return to Home
        </a>
      </div>
      <div v-else class="py-12">
        <div class="mb-6">
          <svg class="mx-auto h-16 w-16 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h1 class="font-header text-[1.5rem] font-bold text-primary mb-4">Unsubscribe Failed</h1>
        <p class="font-body text-[1.125rem] text-gray-700 leading-[1.75] mb-6">
          {{ errorMessage || 'The unsubscribe link is invalid or has expired. Please contact us if you need assistance.'
          }}
        </p>
        <a href="/contact"
          class="inline-block px-6 py-3 bg-green-700 text-white rounded-md hover:bg-green-800 transition-colors font-header">
          Contact Us
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { API_BASE_URL } from '../config.js'

const loading = ref(true)
const success = ref(false)
const errorMessage = ref('')

onMounted(async () => {
  const urlParams = new URLSearchParams(window.location.search)
  const token = urlParams.get('token')

  if (!token) {
    loading.value = false
    errorMessage.value = 'Missing unsubscribe token'
    return
  }

  try {
    await axios.get(`${API_BASE_URL}/api/newsletter/unsubscribe`, {
      params: { token }
    })
    success.value = true
  } catch (error) {
    console.error('Failed to unsubscribe:', error)
    errorMessage.value = error.response?.data?.error || 'Failed to unsubscribe'
  } finally {
    loading.value = false
  }
})
</script>
